//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueScrollbar from 'vue2-scrollbar';
import {scrolingGallery} from "~/utils/utils";
require("vue2-scrollbar/dist/style/vue2-scrollbar.css")
export default {
  components: {
    VueScrollbar
  },
  data() {
    return {
      items: [],
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        ...scrolingGallery(this, 'masterpieceSelectList')
      }
    }
  },
  methods: {
    toggleSelectItem(){
      this.selectedItems = this.pictures.filter((item) => {
        return item.selected
      })
      this.canSelect = this.selectedItems.length < this.selectCount
    }
  },
}
